import React,{useEffect} from "react"
import { makeStyles } from "@material-ui/core/styles"
import Stepper from "@material-ui/core/Stepper"
import Step from "@material-ui/core/Step"
import StepLabel from "@material-ui/core/StepLabel"
import Check from "@material-ui/icons/Check"
import Close from "@material-ui/icons/Close"
import { green } from '@material-ui/core/colors';

function QontoStepIcon(props) {
    const { completed } = props
    return (
        <div>
            {completed ? (
                <Check style={{ color: green[500] }} />
            ) : (
                    <Close color="error" />
                )}
        </div>
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        width: "100%",
        alignItems: "center"
    },
}))

function getSteps() {
    return ["Received", "Active", "Completed"]
}

export default function StatusStepper({currentStatus}) {
    const classes = useStyles()
    const [activeStep, setActiveStep] = React.useState(currentStatus)
    const steps = getSteps()

    useEffect(() => {
        activeStep !== currentStatus && setActiveStep(currentStatus);
      }, [currentStatus,activeStep])

    return (
        <div className={classes.root}>
            <Stepper activeStep={activeStep}>
                {steps.map(label => (
                    <Step key={label}>
                        <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
        </div>
    )
}